// extracted by mini-css-extract-plugin
export default {"wrapper":"_2_umyzItECO2qW1xkDyjK7","iconLabel":"_1XqlYXf1WmU-IHQrzIHdrM","flexSearchContainer":"_3VRGZUOfyjvsfIcxgrAsAP","searchError":"J--J6B-xENZoYL-H7zTce"};